import { SubscriptionValue } from "../components/stripe/types/SubscriptionTypes"
export interface Subscription {
    subscription_type: SubscriptionValue,
    subscription_label: string,
    cancellable: boolean,
    end_date: string | null,
    next_payment_date: string | null,
    subscription_price: number | null,
}

export interface UserInfo {
    id: string,
    available_reptiles_visible: boolean,
    admin: boolean,
    breeder_name: string,
    breeder_credit: string,
    email: string,
    creation_date: string,
    first_name: string,
    last_name: string,
    scales: number,
    verified: boolean,
    active_paid_subscriptions: Subscription[],
    subscription: Subscription | null,
    eligible_for_free_trial: boolean
}
export const blankUserInfo: UserInfo = {
    id: '',
    admin: false,
    breeder_name: "",
    breeder_credit: "",
    email: "",
    creation_date: "",
    first_name: "",
    last_name: "",
    scales: 0,
    verified: false,
    active_paid_subscriptions: [],
    subscription: null,
    eligible_for_free_trial: true
}
